import {createSelector} from 'reselect';

import {buildGroupsAccessibleByUser} from '../../../helpers/models/cardGroupHelpers';
import {AppParametricSelector} from '../../../helpers/reselectHelpers';
import {CardModel} from '../../../models/api/cardModel';
import {getCardGroups} from '../dataSelectors';
import {getUserNamespace} from '../teammates/teammatesSelectors';
import {getUserTeams} from '../teams/teamsSelectors';

type CardSelector<P> = AppParametricSelector<P, CardModel | undefined>;
export function makeGetCardGroups<P>(getCard: CardSelector<P>) {
  return createSelector(
    [getCard, getCardGroups, getUserTeams, getUserNamespace],
    (card, groups, userTeams, userNamespace) =>
      buildGroupsAccessibleByUser(groups, card?.groupIds ?? [], userTeams, userNamespace),
  );
}
